import React from 'react'
import { Nav } from '../Components/Nav'
import { Footer } from '../Components/Footer'
// import { AboutBody } from '../Components/AboutBody'
import AboutComponent from '../Components/AboutComponent'

export const About = () => {
    return (
        <div className='overflow-x-hidden'>
            <Nav />
            <AboutComponent />
            <Footer />
        </div>
    )
}
